import { AlertTriangle, HelpCircle, Upload, RefreshCw, UserCheck, Calculator } from "lucide-react";

// Record-origin metadata — distinct from the field/metric DataStatusChip.
export const ORIGIN_META = {
  sample: {
    label: "Sample", full: "Sample / demo data — not real",
    tone: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500", Icon: AlertTriangle,
  },
  unverified: {
    label: "Unverified", full: "Origin unknown — verify before relying on it",
    tone: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500", Icon: HelpCircle,
  },
  imported: {
    label: "Imported", full: "Uploaded via the Import Hub",
    tone: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500", Icon: Upload,
  },
  synced: {
    label: "Synced", full: "Ingested from AroFlo / MYOB / API",
    tone: "bg-teal-50 text-teal-700 border-teal-200", dot: "bg-teal-500", Icon: RefreshCw,
  },
  manual: {
    label: "Manual", full: "Entered by a user in the hub",
    tone: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", Icon: UserCheck,
  },
  calculated: {
    label: "Hub Calculated", full: "Computed by the hub from source data",
    tone: "bg-violet-50 text-violet-700 border-violet-200", dot: "bg-violet-500", Icon: Calculator,
  },
};

export const ORIGIN_ORDER = ["sample", "unverified", "imported", "synced", "manual", "calculated"];

// Map a frontend route path → provenance module key used by the banner.
export function moduleForPath(pathname) {
  const p = pathname || "";
  if (p === "/") return "executive";
  if (p.startsWith("/finance")) return "finance";
  if (p.startsWith("/operations")) return "operations";
  if (p.startsWith("/crm") || p.startsWith("/sales") || p.startsWith("/feedback") || p.startsWith("/contracts")) return "crm";
  if (p.startsWith("/hseq")) return "hseq";
  if (p.startsWith("/hr")) return "hr";
  if (p.startsWith("/vehicles")) return "fleet";
  if (p.startsWith("/assets")) return "capital";
  return null;
}
